import React, { FC, ReactElement, useRef } from 'react';
import { Button, Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ServiceTypeEnum } from '../../domain/enums/ServiceTypeEnum';
import { MetadataType } from '../../domain/interfaces/api/IMetadata';
import ITopBarProps from '../../domain/interfaces/components/ITopBarProps';

const TopBar: FC<ITopBarProps> = (props): ReactElement => {
  const { t } = useTranslation();
  const searchInputRef = useRef<HTMLInputElement | null>(null);
  const categorySelectRef = useRef<HTMLSelectElement | null>(null);
  const teacherSelectRef = useRef<HTMLSelectElement | null>(null);

  const renderOptions = (data: MetadataType[]) => {
    return (
      data &&
      Array.isArray(data) &&
      data.map((value: MetadataType) => (
        <option key={value.id} value={value.id}>
          {value.name}
        </option>
      ))
    );
  };

  const triggerSearch = () => {
    const rawSearch = searchInputRef.current?.value?.trim() || '';
    let selectedCategory = categorySelectRef.current?.value || '-1';
    let selectedTeacher = teacherSelectRef.current?.value || '-1';
    let finalKeyword = rawSearch;

    // Automatyczne dopasowanie prelegenta po nazwisku wpisanym w pole tekstowe
    if (selectedTeacher === '-1' && rawSearch.length >= 3 && props.teacherItems) {
      const matchedTeacher = props.teacherItems.find((teacher) =>
        teacher.name.toLowerCase().includes(rawSearch.toLowerCase())
      );

      if (matchedTeacher) {
        selectedTeacher = String(matchedTeacher.id);
        if (teacherSelectRef.current) {
          teacherSelectRef.current.value = String(matchedTeacher.id);
        }
        finalKeyword = '';
      }
    }

    props.handleSearchAndFlters(finalKeyword, selectedCategory, selectedTeacher);
  };

  // Użycie ogólnego typu React.KeyboardEvent rozwiązuje błąd TS2322
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      triggerSearch();
    }
  };

  return (
    <Row className="g-2 align-items-center justify-content-center">
      <Col lg={4}>
        <FloatingLabel
          controlId="floatingInputGrid"
          label={t('components.consultancy.search_label')}
        >
          <Form.Control
            ref={searchInputRef}
            type="text"
            onKeyDown={handleKeyDown}
            placeholder={t('components.consultancy.search_placeholder')}
            defaultValue={
              props.defaultKeyword !== 'null' ? props.defaultKeyword : ''
            }
          />
        </FloatingLabel>
      </Col>

      <Col lg={3}>
        <FloatingLabel
          controlId="floatingSelectGrid"
          label={t('components.consultancy.category_label')}
        >
          <Form.Select
            aria-label={t('components.consultancy.category_label')}
            ref={categorySelectRef}
            defaultValue={props.defaultCategory || '-1'}
          >
            <option value="-1">Wybierz jedną kategorię</option>
            {renderOptions(props.categoryItems)}
          </Form.Select>
        </FloatingLabel>
      </Col>

      <Col lg={3}>
        <FloatingLabel
          controlId="floatingSelectGrid"
          label={t('components.consultancy.teacher_label')}
        >
          <Form.Select
            aria-label={t('components.consultancy.teacher_label')}
            ref={teacherSelectRef}
            defaultValue={props.defaultTeacher || '-1'}
          >
            <option value="-1">Wybierz prelegenta</option>
            {renderOptions(props.teacherItems)}
          </Form.Select>
        </FloatingLabel>
      </Col>

      <Col lg={2}>
        <Button
          className={`${
            props.type === ServiceTypeEnum.VIDEO ? 'purple-btn' : 'pink-btn'
          } w-100`}
          size="lg"
          onClick={triggerSearch}
        >
          {t('components.consultancy.search_btn_label')}
        </Button>
      </Col>
    </Row>
  );
};

export default TopBar;